

export const relevanceScoreData = [
  {
    id: 1,
    name: "Youtube",
    score: 98,
    image: "youtube",
  },
  {
    id: 2,
    name: "Instagram",
    score: 95,
    image: "instagram",
  },
  {
    id: 3,
    name: "Tiktok",
    score: 90,
    image: "tiktok",
  },
  {
    id: 4,
    name: "Facebook",
    score: 80,
    image: "facebook",
  },
  {
    id: 5,
    name: "Twitter",
    score: 70,
    image: "twitter",
  },
  {
    id: 6,
    name: "LinkedIn",
    score: 60,
    image: "linkedin",
  },
  {
    id: 7,
    name: "Reddit",
    score: 8,
    image: "reddit",
  },
];

export const channelDetailsColumns = [
  {
    id: "cluster",
    label: "Cluster",
    width: "25%",
  },
  {
    id: "contentType",
    label: "Content Type",
    width: "20%",
  },
  {
    id: "title",
    label: "Title",
    width: "30%",
  },
  {
    id: "description",
    label: "Description",
    width: "25%",
  },
];

export const channelDetailsRows = [
  {
    cluster: "gary brecka cold plunge youtube",
    contentType: "Interview/Insight Video",
    title: "Gary Brecka on Cold Plunges:Benefits and Personal Insights",
    description:
      "Explore Gary Brecka's personal experience and insights on cold  plunging, highlighting its benefits and  tips for beginners.",
  },
  {
    cluster: "gary brecka cold plunge youtube",
    contentType: "Interview/Insight Video",
    title: "Gary Brecka on Cold Plunges:Benefits and Personal Insights",
    description:
      "Explore Gary Brecka's personal experience and insights on cold  plunging, highlighting its benefits and  tips for beginners.",
  },
  {
    cluster: "gary brecka cold plunge youtube",
    contentType: "Interview/Insight Video",
    title: "Gary Brecka on Cold Plunges:Benefits and Personal Insights",
    description:
      "Explore Gary Brecka's personal experience and insights on cold  plunging, highlighting its benefits and  tips for beginners.",
  },
  {
    cluster: "gary brecka cold plunge youtube",
    contentType: "Interview/Insight Video",
    title: "Gary Brecka on Cold Plunges:Benefits and Personal Insights",
    description:
      "Explore Gary Brecka's personal experience and insights on cold  plunging, highlighting its benefits and  tips for beginners.",
  },
  {
    cluster: "gary brecka cold plunge youtube",
    contentType: "Interview/Insight Video",
    title: "Gary Brecka on Cold Plunges:Benefits and Personal Insights",
    description:
      "Explore Gary Brecka's personal experience and insights on cold  plunging, highlighting its benefits and  tips for beginners.",
  },
  {
    cluster: "gary brecka cold plunge youtube",
    contentType: "Interview/Insight Video",
    title: "Gary Brecka on Cold Plunges:Benefits and Personal Insights",
    description:
      "Explore Gary Brecka's personal experience and insights on cold  plunging, highlighting its benefits and  tips for beginners.",
  },
  {
    cluster: "gary brecka cold plunge youtube",
    contentType: "Interview/Insight Video",
    title: "Gary Brecka on Cold Plunges:Benefits and Personal Insights",
    description:
      "Explore Gary Brecka's personal experience and insights on cold  plunging, highlighting its benefits and  tips for beginners.",
  },
  {
    cluster: "gary brecka cold plunge youtube",
    contentType: "Interview/Insight Video",
    title: "Gary Brecka on Cold Plunges:Benefits and Personal Insights",
    description:
      "Explore Gary Brecka's personal experience and insights on cold  plunging, highlighting its benefits and  tips for beginners.",
  },
];



export const actionsRows = [
  {
    "classification": "subtopic",
    "keyword": "roof leak repair",
    "pageType": "Landing Page",
    "parentKW": "leak repair",
    "searchIntent": "navigational",
    "searchVolume": 598,
    "relevanceScore": 0.24,
  },
  {
    "classification": "page",
    "keyword": "slab leak repair",
    "pageType": "Product Page",
    "parentKW": "pipe repair",
    "searchIntent": "transactional",
    "searchVolume": 538,
    "relevanceScore": 0.31,
  },
  {
    "classification": "page",
    "keyword": "slab leak repair cost",
    "pageType": "Commercial Landing Page",
    "parentKW": "pipe repair",
    "searchIntent": "commercial",
    "searchVolume": 537,
    "relevanceScore": 0.28,
  },
  {
    "classification": "page",
    "keyword": "oil leak repair cost",
    "pageType": "Commercial Landing Page",
    "parentKW": "pipe repair",
    "searchIntent": "commercial",
    "searchVolume": 478,
    "relevanceScore": 0.29,
  },
  {
    "classification": "page",
    "keyword": "leak detection near me",
    "pageType": "Product Page",
    "parentKW": "pipe repair",
    "searchIntent": "transactional",
    "searchVolume": 478,
    "relevanceScore": 0.41,
  },
  {
    "classification": "subtopic",
    "keyword": "pvc pipe repair",
    "pageType": "Product Page",
    "parentKW": "pipe repair",
    "searchIntent": "transactional",
    "searchVolume": 417,
    "relevanceScore": 0.34,
  },
  {
    "classification": "subtopic",
    "keyword": "exhaust pipe repair",
    "pageType": "Product Page",
    "parentKW": "pipe repair",
    "searchIntent": "transactional",
    "searchVolume": 358,
    "relevanceScore": 0.31,
  },
  {
    "classification": "subtopic",
    "keyword": "roof leak repair near me",
    "pageType": "Landing Page",
    "parentKW": "leak repair",
    "searchIntent": "navigational",
    "searchVolume": 299,
    "relevanceScore": 0.27,
  },
  {
    "classification": "page",
    "keyword": "coolant leak repair",
    "pageType": "Product Page",
    "parentKW": "pipe repair",
    "searchIntent": "transactional",
    "searchVolume": 298,
    "relevanceScore": 0.27,
  },
  {
    "classification": "page",
    "keyword": "pipe leak repair",
    "pageType": "Product Page",
    "parentKW": "pipe repair",
    "searchIntent": "transactional",
    "searchVolume": 295,
    "relevanceScore": 0.25,
  },
  {
    "classification": "subtopic",
    "keyword": "main water line leak repair",
    "pageType": "Landing Page",
    "parentKW": "leak repair",
    "searchIntent": "navigational",
    "searchVolume": 285,
    "relevanceScore": 0.22,
  },
  {
    "classification": "page",
    "keyword": "underground pipe leak repair",
    "pageType": "Product Page",
    "parentKW": "pipe repair",
    "searchIntent": "transactional",
    "searchVolume": 270,
    "relevanceScore": 0.29,
  },
  {
    "classification": "page",
    "keyword": "water pipe leak repair",
    "pageType": "Product Page",
    "parentKW": "pipe repair",
    "searchIntent": "transactional",
    "searchVolume": 260,
    "relevanceScore": 0.30,
  },
  {
    "classification": "subtopic",
    "keyword": "pipe leak detection",
    "pageType": "Landing Page",
    "parentKW": "leak repair",
    "searchIntent": "navigational",
    "searchVolume": 250,
    "relevanceScore": 0.23,
  },
  {
    "classification": "page",
    "keyword": "pipe repair service",
    "pageType": "Product Page",
    "parentKW": "pipe repair",
    "searchIntent": "transactional",
    "searchVolume": 240,
    "relevanceScore": 0.28,
  }
]
